import { AttachmentInterface } from '@onArte/shared/interfaces/common/attachments';

export class PublicProfileVersionDataModel {
  public name: string;
  public description: string;
  public bio: string;
  public attachments: AttachmentInterface[];
}
